/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import { NumericFormat, NumericFormatProps } from "react-number-format";
import AnyUtil from "../../Utils/AnyUtil";

export interface GanzzahlFormatProps extends NumericFormatProps {
    onChange: (event: { target: { name?: string; value: string } }) => void;
    name?: string;
    allowNegative?: boolean;
}

export default React.forwardRef<typeof NumericFormat, GanzzahlFormatProps>(function (props, ref) {
    const { onChange, value, min, max, ...other } = props;
    return (
        <NumericFormat
            {...other}
            value={value === null || value === undefined ? "" : value}
            getInputRef={ref}
            onValueChange={(values) => {
                onChange({
                    target: {
                        name: props.name,
                        value: values.value,
                    }
                });
            }}
            isAllowed={values => {
                let isAllowed = true;
                if (!AnyUtil.isNullOrUndefined(values.floatValue)) {
                    const minNumber = typeof min === "number"
                        ? min : min !== ""
                            ? Number(min) : Number.NEGATIVE_INFINITY;
                    if (!isNaN(minNumber) && values.floatValue < minNumber) {
                        isAllowed = false;
                    }

                    const maxNumber = typeof max === "number"
                        ? max : max !== ""
                            ? Number(max) : Number.POSITIVE_INFINITY;
                    if (!isNaN(maxNumber) && values.floatValue > maxNumber) {
                        isAllowed = false;
                    }
                }

                return isAllowed;
            }}
            valueIsNumericString={false}
            decimalScale={0}
        />
    );
});